import { defineAsyncComponent } from 'vue'
export default {
  "admin-default": defineAsyncComponent(() => import("/app/layouts/admin/default.vue").then(m => m.default || m)),
  "admin-maindashboard": defineAsyncComponent(() => import("/app/layouts/admin/maindashboard.vue").then(m => m.default || m)),
  custom: defineAsyncComponent(() => import("/app/layouts/custom.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/app/layouts/landing.vue").then(m => m.default || m)),
  maindashboard: defineAsyncComponent(() => import("/app/layouts/maindashboard.vue").then(m => m.default || m))
}